<template>
    <div class="bg_F9F8F7 body_bg">
        <nav-bar :navigationIndex="1" @customEvent="parentMethod" />
        <div class="project_detail_box bg_fff_box w_1280">
            <div class="w_1280">
                <div class="fz20 color_B5B5B5">
                    <span class="cursor" @click="goPage('/dailyJiaoYi')">每日焦易</span>>产品详情
                </div>

                <div class="detail_one flex_between">
                    <div class="detail_img">
                        <div class="flex">
                            <div class="cursor flex_center" :class="imgIndex == 1 ? 'select_img_nav' : 'img_nav'"
                                @click="selectImgIndex(1)">图片</div>
                            <div class="cursor flex_center" :class="imgIndex == 2 ? 'select_img_nav' : 'img_nav'"
                                @click="selectImgIndex(2)">质检单</div>
                        </div>
                    </div>
                    <div class="detail_info">
                        <div class="info_name">{{ isLogin ? supplyDemandDetails.productTypeName : '****' }}</div>
                        <div class="info_company_name" v-if="supplyDemandDetails.clientName">
                            <img src="@/assets/images/companyLogo.png" alt="" />{{ supplyDemandDetails.clientName.substring(0, 6)+'****有限公司' }}
                        </div>
                        <div class="info_text">
                            {{ supplyDemandDetails.productTypeDescription }}
                        </div>
                        <div class="info_data_list flex_between">
                            <div class="info_data_box flex_center flex_column">
                                <span>{{ isLogin ? supplyDemandDetails.dealMoneySingle : '****' }}</span>
                                <div class="fz15 color_707070">产品单价(元/吨)</div>
                            </div>
                            <div class="info_data_line"></div>
                            <div class="info_data_box flex_center flex_column">
                                <span>{{ isLogin ? supplyDemandDetails.dealProductCount : '****' }}</span>
                                <div class="fz15 color_707070">数量(吨)</div>
                            </div>
                            <div class="info_data_line"></div>
                            <div class="info_data_box flex_center flex_column" v-if="supplyDemandDetails.createTime">
                                <span>{{ isLogin ? filterTimeYear(supplyDemandDetails.createTime) : '****' }}</span>
                                <div class="fz15 color_707070">发布日期</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail_two">
                    <div class="parameter_title W_1280">
                        <div class="parameter_title_ch">产品参数</div>
                        <div class="parameter_title_en">INTRODUCTION</div>
                    </div>

                    <div class="parameter_list" v-if="supplyDemandDetails.propertyList">
                        <div class="parameter_strip_one flex color_fff fz30">
                            <div class="parameter_box_one flex_center " :class="index < 2 ? 'border_fff' : ''"
                                v-for="(item, index) in supplyDemandDetails.propertyList.slice(0, 3)" :key="item.code">
                                {{ item.name }}
                            </div>
                            <!-- <div class="parameter_box_one flex_center border_fff">钒</div>
                            <div class="parameter_box_one flex_center">粉末电阻率</div> -->
                        </div>
                        <div class="parameter_strip_two flex color_B5B5B5 fz24">
                            <div class="parameter_box_one flex_center border_959595"
                                :class="index < 2 ? 'border_959595' : ''"
                                v-for="(item, index) in supplyDemandDetails.propertyList.slice(0, 3)" :key="item.code">
                                {{ isLogin ? item.value : '****' }}{{ isLogin ? item.unit : '****' }}</div>
                        </div>
                        <div class="parameter_strip_one flex color_fff fz30">
                            <div class="parameter_box_two flex_center" :class="index < 2 ? 'border_fff' : ''"
                                v-for="(item, index) in supplyDemandDetails.propertyList.slice(3, 7)" :key="item.code">
                                {{ item.name }}</div>
                        </div>
                        <div class="parameter_strip_two flex color_B5B5B5 fz24">
                            <div class="parameter_box_two flex_center" :class="index < 3 ? 'border_959595' : ''"
                                v-for="(item, index) in supplyDemandDetails.propertyList.slice(3, 7)" :key="item.code">
                                {{ isLogin ? item.value : '****' }}{{ isLogin ? item.unit : '****' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
import { supplyDemandInfo } from "@/utils/homeApi";
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
            supplyDemandDetails: {},
            imgIndex: 1,
            isLogin: false,
        }
    },
    mounted() {
        window.scrollTo({
            top: 460,
            behavior: 'smooth'
        });
        if (this.$route.query.id) {
            let id = this.$route.query.id;
            let marketType = this.$route.query.marketType
            this.getSupplyDemandInfo(id, marketType);
        }
    },
    methods: {
        // 父组件的方法
        parentMethod(type) {
            console.log('父组件方法被调用', type);
            this.isLogin = type;
        },
        // 产品详情
        async getSupplyDemandInfo(id, marketType) {
            let res = await supplyDemandInfo({ marketId: id, marketType: marketType });
            if (res.code == 200) {
                this.supplyDemandDetails = res.data;
            }
        },

        selectImgIndex(index) {
            this.imgIndex = index;
        },

        // 跳转页面
        goPage(path) {
            this.$router.push({
                path: path,
            });
        },

        filterTimeYear(time) {
            return time.split(" ")[0].split("-")[0];
        },
    }
}
</script>

<style scoped lang="scss">
.body_bg {
    background: url("@/assets/images/newsbg.png") center no-repeat;
    background-size: cover;
}

.project_detail_box {
    padding-top: 65px;
    padding-bottom: 130px;
    margin-bottom: 66px;
}

.detail_one {
    margin-top: 69px;
}

.detail_img {
    width: 582px;
    height: 370px;
    background-color: aqua;
    box-shadow: 3px 8px 13px 0px rgba(85, 85, 85, 0.22);
    padding: 25px 30px;
    background: url("@/assets/images/detailBg.jpg") no-repeat center;
    background-size: 100% 100%;
}

.img_nav {
    width: 98px;
    height: 37px;
    background: #C4D2E8;
    border-radius: 18px;
    font-size: 17px;
    color: #FFFFFF;
    margin-right: 12px;
}

.select_img_nav {
    width: 98px;
    height: 37px;
    background: linear-gradient(12deg, #3881F8 15%, #72AFFD 99%);
    border-radius: 18px;
    font-size: 17px;
    color: #FFFFFF;
    margin-right: 12px;
}

.detail_info {
    width: 580px;
}

.info_name {
    font-weight: bold;
    font-size: 45px;
    color: #313131;
}

.info_company_name {
    font-weight: bold;
    font-size: 30px;
    color: #313131;
    margin-top: 45px;
}

.info_company_name img {
    width: 34px;
    height: 38px;
    margin-right: 20px;
    object-fit: cover;
}

.info_text {
    font-size: 18px;
    color: #898989;
    margin: 26px 0 46px 0;
}

.info_data_list {}

.info_data_box span {
    font-weight: bold;
    font-size: 49px;
    color: #343434;
    line-height: 49px;
}

.info_data_line {
    width: 1px;
    height: 17px;
    background-color: #898989;
}

.detail_two {
    margin-top: 180px;
}

.parameter_title_ch {
    font-weight: bold;
    font-size: 48px;
    color: #333333;
}

.parameter_title_en {
    font-size: 20px;
    color: #333333;
}

.parameter_list {
    margin-top: 37px;
}

.border_fff {
    border-right: 1px solid #fff;
}

.border_959595 {
    border-right: 1px solid #959595;
}

.parameter_strip_one {
    height: 88px;
    background: #317FF4;
    border: 1px solid #317FF4;
}

.parameter_box_one {
    width: 426px;
    height: 100%;
}

.parameter_strip_two {
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #959595;
}

.parameter_box_two {
    width: 319px;
    height: 100%;
}
</style>